<template>
    <v-menu left offset-y min-width="140">
            <template v-slot:activator="{ on }">

                <v-btn
                  class="px-1 button-text secondary--text text--lighten-1 subtitle-2 font-weight-medium"
                  height="40"
                  v-on="on"
                  text
                >
                  <v-icon class="mr-2">mdi-export-variant</v-icon>
                  <span class="hidden-sm-and-down">Exportar a tabela</span>
                  <span class="hidden-md-and-up">Exportar</span>
                </v-btn>

            </template>

            <v-list class="py-4">
                <v-list-item link @click="exportPDF()">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-file-document-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Baixar documento PDF</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportCSV">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-file-table-box-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Baixar documento CSV</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="exportXLS">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-file-table-box-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Baixar documento XLS</span>
                    </v-list-item-content>
                </v-list-item>
           </v-list>

        </v-menu>
</template>

<script>
export default {
    name: 'ChartExportMenu',
    data: ()=>({
    }),
    methods:{
        fullscreenChart(){
            this.$emit('fullscreenChart');
        },
        printChart(){
            this.$emit('printChart');
        },
        exportChart(type){
            this.$emit('exportChart', type);
        },
        exportPDF(){
            this.$emit('exportPDF');
        },
        exportCSV(){
            this.$emit('exportCSV');
        },
        exportXLS(){
            this.$emit('exportXLS');
        }
    }
}
</script>

<style>

</style>
